/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Challenge_ShortInputs */

const es_home_usecases_challenge_short = /** @type {(inputs: Home_Usecases_Challenge_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desafío`)
};

const en_home_usecases_challenge_short = /** @type {(inputs: Home_Usecases_Challenge_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Challenge`)
};

/**
* | output |
* | --- |
* | "Challenge" |
*
* @param {Home_Usecases_Challenge_ShortInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_challenge_short = /** @type {((inputs?: Home_Usecases_Challenge_ShortInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Challenge_ShortInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_challenge_short(inputs)
	return en_home_usecases_challenge_short(inputs)
});
export { home_usecases_challenge_short as "home.usecases.challenge_short" }